import script from "./ext.cattle.io.kubeconfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./ext.cattle.io.kubeconfig.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__